module.exports = __webpack_public_path__ + "img/img1.b98e0eac.jpg";